import { render, staticRenderFns } from "./assetClassManagement.vue?vue&type=template&id=f317ae42&"
import script from "./assetClassManagement.vue?vue&type=script&lang=js&"
export * from "./assetClassManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports